import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 100px);
  height: calc(100% - 50px);
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;

export const InfoContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  text-align: center;
  margin: 0px auto 10px auto;

  @media (max-width: 1585px) {
    margin: 0px auto 60px auto;
  }
`;

export const Medicao = styled.label`
  font-size: 14px;
  font-weight: bold;
  color: ${(props) => props.theme.colors.darkerblue};
`;

export const ValueContainer = styled.div`
  display: flex;
  width: fit-content;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    props.title === 'light'
      ? props.theme.colors.white
      : props.theme.colors.darker};
  box-shadow: none;
  border-radius: 6px;
  padding: 10px 20px;
`;

export const Value = styled.label`
  font-size: 25px;
  font-weight: bold;
  color: ${(props) =>
    props.title === 'light'
      ? props.theme.colors.black
      : props.theme.colors.label};
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  height: 10vh;
  z-index: 10;

  @media (max-width: 1280px) {
    #line {
      display: none;
    }
  }
`;

export const Line = styled.img`
  width: 155px;
  height: 95px;
`;

export const ProdutoImage = styled.img`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  max-width: 350px;
  max-height: 300px;
  min-width: 300px;
  min-height: 180px;
  object-fit: contain;

  @media (max-width: 1280px) {
    width: 300px;
    margin: 40px;
  }
  @media (max-width: 950px) {
    width: 255px;
  }
  /* min-width 300px transbordava em phones <=375px. Solta o min e usa
     fluido. Margens tambem encolhem. */
  @media (max-width: 720px) {
    width: 100%;
    min-width: 0;
    max-width: min(255px, 70vw);
    margin: 16px auto;
  }
`;
